<template>
    <div class="body">
        <div class="title">
            发布
            <!-- 面包屑导航区域 -->
            <div class="fansk">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf"> 首页 </span></el-breadcrumb-item>
                    <el-breadcrumb-item>发布管理</el-breadcrumb-item>
                    <el-breadcrumb-item>活动管理</el-breadcrumb-item>
                    <el-breadcrumb-item>
                        <span class="dsadf"> 发布 </span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <div style="margin: -20px 0 20px">
            <el-button size="mini" @click="$router.back()">返回</el-button>
        </div>

        <el-card>
            <el-form ref="form" :model="addQuery" :rules="rules" label-width="120px" :label-position="labelPosition" @submit.native.prevent>
                <!-- <el-form-item label="发布者名称" label-width="13%">
                    <el-input v-model="addQuery.user_name" style="width: 400px;" placeholder="请输入发布者名称"></el-input>
                </el-form-item>
                <el-form-item label="logo" label-width="13%">
                    <div class="imgbox" v-if="addQuery.user_logo !== ''">
                        <img :src="addQuery.user_logo" alt="" class="imgs" />
                        <img src="../../assets/img/shanchu.png" mode="" class="close" @click="closeuserLogo" v-if="addQuery.user_logo !== ''" />
                    </div>
                    <el-upload v-if="addQuery.user_logo === ''" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarSuccessLogo" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item> -->

                <el-form-item label="内容形式" prop="enroll_switch" label-width="13%">
                    <el-radio-group v-model="addQuery.enroll_switch">
                        <el-radio label="0">信息资讯</el-radio>
                        <el-radio label="1">活动报名</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="活动名称" prop="name" label-width="13%">
                    <el-input v-model="addQuery.name" style="width: 400px;" placeholder="请输入活动标题"></el-input>
                </el-form-item>

                <el-form-item label="方式" prop="type" label-width="13%">
                    <el-radio-group v-model="addQuery.type">
                        <el-radio label="1">赛事</el-radio>
                        <el-radio label="2">党建</el-radio>
                        <el-radio label="3">培训</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="项目" prop="sport_type" label-width="13%">
                    <el-checkbox-group v-model="addQuery.sport_type">
                        <el-checkbox v-for="(item) in sportTypes" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox>
                    </el-checkbox-group>
                    <!-- <el-select :multiple="true" multiple-limit="1" style="width: 400px" v-model="addQuery.sport_type" placeholder="选择活动类型">
                        <el-option v-for="item in sportTypes" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select> -->
                </el-form-item>
                 <!-- <el-form-item label="活动场地" prop="site_type" label-width="13%">
                    <el-select v-model="addQuery.site_type" multiple placeholder="请选择场地" filterable style="width:400px">
                      <el-option
                        v-for="item in sportSites"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item v-if="addQuery.enroll_switch == 1" label="活动分组" prop="act_group_ids" label-width="13%">
                    <div>
                        <el-radio-group v-model="addQuery.group_switch">
                            <el-radio label="0">不设分组</el-radio>
                            <el-radio label="1">自定义分组</el-radio>
                        </el-radio-group>
                    </div>
                    <div v-if="addQuery.group_switch == 1">
                        <el-input v-model="activeGroupForm.name" size="small" placeholder="组名" style="width: 150px; margin-right: 10px">
                        </el-input>
                        <el-input v-model="activeGroupForm.number" size="small" placeholder="人数" style="width: 80px; margin-right: 10px">
                        </el-input>
                        <!-- <el-input v-model="activeGroupForm.age" size="small" placeholder="年龄" style="width: 80px; margin-right: 10px">
                        </el-input> -->

                        <el-date-picker
                            v-model="activeGroupForm.ageStart"
                            size="small"
                            type="year"
                            value-format="yyyy"
                            placeholder="最小年龄"
                            :picker-options="pickerOptionsAge"
                            style="width: 120px; margin-right: 10px">
                        </el-date-picker>
                        <el-date-picker
                            v-model="activeGroupForm.ageEnd"
                            size="small"
                            type="year"
                            value-format="yyyy"
                            placeholder="最大年龄"
                            :picker-options="pickerOptionsAge"
                            style="width: 120px; margin-right: 10px">
                        </el-date-picker>
                        <!-- <el-input v-model="activeGroupForm.sex" size="small" placeholder="性别" style="width: 80px; margin-right: 10px">
                        </el-input> -->
                        <el-select v-model="activeGroupForm.sex" size="small" placeholder="性别" style="width: 100px; margin-right: 10px">
                            <el-option v-for="item in sexList" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>
                        <!-- <el-button size="small" @click="addGroup" style="width: 80px">添加</el-button> -->
                        <el-button size="small" @click="addGroup2" style="width: 80px">添加</el-button>
                        <div>
                            <el-tag :key="tag.id" v-for="(tag, index) in activeGroup" closable :disable-transitions="false" style="margin: 10px 10px 0 0" @close="deleteGroup(tag, index)">
                                {{ tag.title }}
                            </el-tag>
                        </div>
                    </div>
                </el-form-item>

                <el-form-item label="宣传图片" prop="pics" label-width="13%">
                    <div class="from">
                        <div class="imgbox" v-for="(item, index) in addQuery.pics" :key="index">
                            <img :src="item.name" alt="" class="imgs" />
                            <img src="../../assets/img/shanchu.png" mode="" class="close" @click="closeImgs(index)" v-if="item" />
                        </div>
                    </div>
                    <el-upload v-if="addQuery.pics.length !== 9" class="upload-demo" ref="upload" action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic" :on-progress="progress" :on-success="handleAvatarSuccess" :limit="9" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                        <el-button size="small" type="primary">选择</el-button>
                    </el-upload>
                </el-form-item>

                <el-form-item label="介绍" prop="introduce" label-width="13%">
                    <quill-editor class="appwrapper" v-model="addQuery.introduce" :rows="3" ref="myQuillEditor" :options="editorOption" style="width: 50%">
                    </quill-editor>
                </el-form-item>

                <el-form-item label="总结" label-width="13%">
                    <quill-editor class="appwrapper" v-model="addQuery.summarize" :rows="3" ref="myQuillEditor2" :options="editorOption2" style="width: 50%">
                    </quill-editor>
                </el-form-item>

                <el-form-item v-if="addQuery.enroll_switch == 1" label="报名时间" prop="enroll_starttime" label-width="13%">
                    <el-date-picker v-model="enrolltime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" @change="changeEnrolltime">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="时间" prop="act_starttime" label-width="13%">
                    <el-date-picker v-model="acttime" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" @change="changeActtime">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="地址" prop="address" label-width="13%"
                    @click.native="GetJWD('address', addQuery.signin_distance, addQuery.address, addQuery.longitude, addQuery.latitude)">
                    <el-input v-model="addQuery.address" prefix-icon="el-icon-location" readonly placeholder="请选择"
                    style="width: 400px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="活动地址" prop="area_id" label-width="13%">
                    <el-cascader :props="checkedData.typeOptions" @change="changList"></el-cascader>
                </el-form-item>
                <el-form-item label="" prop="address" label-width="13%">
                    <el-input v-model="addQuery.address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="" prop="longitude" label-width="13%">
                    <el-row style="margin-bottom: 10px">
                        <vxe-button size="medium" content="获取活动位置经纬度" status="primary" @click="GetJWD('address')"></vxe-button>
                    </el-row>
                    <el-row style="margin-bottom: 10px">
                        <el-input v-model="addQuery.longitude" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                    </el-row>
                    <el-row>
                        <el-input v-model="addQuery.latitude" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                    </el-row>
                </el-form-item> -->

                <!-- 活动报名 -->
                <template v-if="addQuery.enroll_switch == 1">
                    <!-- 签到 -->
                    <el-form-item label="活动签到" label-width="13%">
                        <el-radio v-model="isNotSignin" :label="true" @input="inputIsNotSignin">无需签到</el-radio>
                        <el-radio v-for="(item, index) in signInList" :key="item.value" v-model="addQuery.signin_type[index]"
                        :label="item.value" @click.native.prevent="clickSigninType(index)">{{ item.label }}</el-radio>
                    </el-form-item>
                    <!-- <el-form-item label="是否需要签到" label-width="13%">
                        <el-switch v-model="isSignin" active-text="是" inactive-text="否">
                        </el-switch>
                    </el-form-item> -->

                    <template v-if="!isNotSignin">
                        <el-form-item label="签到时间" prop="signin_starttime" label-width="13%">
                            <el-date-picker v-model="signintime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
                                end-placeholder="结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" @change="changeSignintime">
                            </el-date-picker>
                        </el-form-item>

                        <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到位置" prop="signin_address"
                        label-width="13%" @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat)">
                            <el-input v-model="addQuery.signin_address" prefix-icon="el-icon-location" readonly placeholder="请选择"
                                style="width: 400px;"></el-input>
                        </el-form-item> -->
                        <!-- signin_lng signin_lat -->
                        <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到位置" prop="signin_address"
                          label-width="13%" @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat)">
                          <el-input disabled v-model="addQuery.signin_address" prefix-icon="el-icon-location" readonly placeholder="请选择"
                            style="width: 400px;"></el-input>
                        </el-form-item> -->
                        <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到位置" prop="signin_address"
                          label-width="13%">
                          <el-input disabled v-model="addQuery.signin_address" prefix-icon="el-icon-location" readonly placeholder="请选择"
                            style="width: 400px;"></el-input>
                        </el-form-item>
                        <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到范围" prop="signin_distance"
                        label-width="13%" @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat)">
                            <el-input disabled v-model="addQuery.signin_distance" readonly placeholder="请选择"
                                style="width: 200px;"></el-input> <span style="color: #999;">米</span>
                        </el-form-item> -->
                        <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到范围" prop="signin_distance"
                        label-width="13%">
                            <el-input disabled v-model="addQuery.signin_distance" readonly placeholder="请选择"
                                style="width: 200px;"></el-input> <span style="color: #999;">米</span>
                        </el-form-item>
                        <!-- <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到范围" prop="signin_distance" label-width="13%">
                            <el-select v-model="addQuery.signin_distance" placeholder="请选择" style="width: 300px">
                                <el-option v-for="item in signInMiList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item label="签到方式" prop="signin_type" label-width="13%">
                            <el-select v-model="addQuery.signin_type" multiple placeholder="请选择" style="width: 300px">
                                <el-option v-for="item in signInList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到地点" prop="signin_address" label-width="13%">
                            <el-input v-model="addQuery.signin_address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                        </el-form-item>
                        <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="" prop="signin_lng" label-width="13%">
                            <el-row style="margin-bottom: 10px">
                                <vxe-button size="medium" content="获取签到地址经纬度" status="primary" @click="GetJWD('qiandao')"></vxe-button>
                            </el-row>
                            <el-row style="margin-bottom: 10px">
                                <el-input v-model="addQuery.signin_lng" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                            </el-row>
                            <el-row>
                                <el-input v-model="addQuery.signin_lat" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                            </el-row>
                        </el-form-item>

                        <el-form-item v-if="addQuery.signin_type.indexOf('1') > -1" label="签到距离" prop="signin_distance" label-width="13%">
                            <el-select v-model="addQuery.signin_distance" placeholder="请选择" style="width: 300px">
                                <el-option v-for="item in signInMiList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item v-if="addQuery.signin_type.indexOf('2') > -1" label="签到二维码" prop="signin_qrcode" label-width="13%">
                            <div class="from">
                                <div v-if="addQuery.signin_qrcode" class="imgbox">
                                    <img :src="addQuery.signin_qrcode" alt="" class="imgs" />
                                    <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signin_qrcode = ''" />
                                </div>
                            </div>
                            <el-upload v-if="!addQuery.signin_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignin_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                                <el-button size="small" type="primary">选择</el-button>
                            </el-upload>
                        </el-form-item> -->
                        <!-- <el-form-item label=" " label-width="13%" v-if="addQuery.signin_type.indexOf('1') > -1">
                            <el-button type="primary" size="small"
                                @click.native="GetJWD('qiandao', addQuery.signin_distance, addQuery.signin_address, addQuery.signin_lng, addQuery.signin_lat, addQuery.signin_distance)">修改签到信息</el-button>
                        </el-form-item> -->
                    </template>

                    <!-- 签退 -->
                    <el-form-item label="活动签退" label-width="13%">
                        <el-radio v-model="isNotSignout" :label="true" @input="inputIsNotSignout">无需签退</el-radio>
                        <el-radio v-for="(item, index) in signOutList" :key="item.value" v-model="addQuery.signout_type[index]"
                        :label="item.value" @click.native.prevent="clickSignoutType(index)">{{ item.label }}</el-radio>
                    </el-form-item>
                    <!-- <el-form-item label="是否需要签退" label-width="13%">
                        <el-switch v-model="isSignout" active-text="是" inactive-text="否">
                        </el-switch>
                    </el-form-item> -->

                    <template v-if="!isNotSignout">
                        <el-form-item label="签退时间" prop="signout_starttime" label-width="13%">
                            <el-date-picker v-model="signouttime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
                                end-placeholder="结束时间" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" @change="changeSignouttime">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退位置" prop="signout_address"
                        label-width="13%" @click.native="GetJWD('qiantui', addQuery.signout_distance, addQuery.signout_address, addQuery.signout_lng, addQuery.signout_lat)">
                            <!-- signout_lng signout_lat -->
                            <el-input v-model="addQuery.signout_address" prefix-icon="el-icon-location" readonly placeholder="请选择"
                                style="width: 400px;"></el-input>
                        </el-form-item>
                        <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退范围" prop="signout_distance"
                            label-width="13%" @click.native="GetJWD('qiantui', addQuery.signout_distance, addQuery.signout_address, addQuery.signout_lng, addQuery.signout_lat)">
                            <el-input v-model="addQuery.signout_distance" readonly placeholder="请选择"
                                style="width: 200px;"></el-input> <span style="color: #999;">米</span>
                        </el-form-item>

                        <!-- <el-form-item label="签退方式" prop="signout_type" label-width="13%">
                            <el-select v-model="addQuery.signout_type" multiple placeholder="请选择" style="width: 300px">
                                <el-option v-for="item in signOutList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item>

                        <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退地点" prop="signout_address" label-width="13%">
                            <el-input v-model="addQuery.signout_address" style="width: 300px" placeholder="请输入详细地址"></el-input>
                        </el-form-item>
                        <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="" prop="signout_lng" label-width="13%">
                            <el-row style="margin-bottom: 10px">
                                <vxe-button size="medium" content="获取签退地址经纬度" status="primary" @click="GetJWD('qiantui')"></vxe-button>
                            </el-row>
                            <el-row style="margin-bottom: 10px">
                                <el-input v-model="addQuery.signout_lng" style="width: 300px" placeholder="请选择经度" disabled></el-input>
                            </el-row>
                            <el-row>
                                <el-input v-model="addQuery.signout_lat" style="width: 300px" placeholder="请选择纬度" disabled></el-input>
                            </el-row>
                        </el-form-item>

                        <el-form-item v-if="addQuery.signout_type.indexOf('1') > -1" label="签退距离" prop="signout_distance" label-width="13%">
                            <el-select v-model="addQuery.signout_distance" placeholder="请选择" style="width: 300px">
                                <el-option v-for="item in signOutMiList" :key="item.value" :label="item.label" :value="item.value" />
                            </el-select>
                        </el-form-item> -->

                        <!-- <el-form-item v-if="addQuery.signout_type.indexOf('2') > -1" label="签退二维码" prop="signout_qrcode" label-width="13%">
                            <div class="from">
                                <div v-if="addQuery.signout_qrcode" class="imgbox">
                                    <img :src="addQuery.signout_qrcode" alt="" class="imgs" />
                                    <img src="../../assets/img/shanchu.png" mode="" class="close" @click="addQuery.signout_qrcode = ''" />
                                </div>
                            </div>
                            <el-upload v-if="!addQuery.signout_qrcode" class="upload-demo" ref="upload" action="/service/admin/upload_pic" :on-progress="progress" :on-success="onSuccessSignout_qrcode" :limit="1" :before-upload="$beforeUploadImage" :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" name="pic">
                                <el-button size="small" type="primary">选择</el-button>
                            </el-upload>
                        </el-form-item> -->
                        <el-form-item label=" " label-width="13%" v-if="addQuery.signout_type.indexOf('1') > -1">
                            <el-button type="primary" size="small"
                                @click.native="GetJWD('qiantui', addQuery.signout_distance, addQuery.signout_address, addQuery.signout_lng, addQuery.signout_lat)">修改签退信息</el-button>
                        </el-form-item>
                    </template>

                    <!-- <el-form-item label="活动路线图" prop="road_map" label-width="13%">
                        <el-input v-model="addQuery.road_map" type="textarea" style="width: 400px;" placeholder="请输入活动路线图"></el-input>
                    </el-form-item> -->

                    <el-form-item label="直播地址" prop="live_link" label-width="13%">
                        <div>
                            <el-radio-group v-model="addQuery.live_switch">
                                <el-radio label="0">无直播</el-radio>
                                <el-radio label="1">有直播</el-radio>
                            </el-radio-group>
                        </div>
                        <div v-if="addQuery.live_switch == 1">
                            <el-radio-group v-model="addQuery.live_type">
                                <el-radio label="1">视频</el-radio>
                                <el-radio label="2">图文</el-radio>
                            </el-radio-group>
                        </div>
                        <el-input v-if="addQuery.live_switch == 1" v-model="addQuery.live_link" placeholder="请输入直播地址" style="width: 400px;"></el-input>
                    </el-form-item>

                    <el-form-item label="支付地址" prop="pay_link" label-width="13%">
                        <div>
                            <el-radio-group v-model="addQuery.pay_switch">
                                <el-radio label="0">无支付</el-radio>
                                <el-radio label="1">有支付</el-radio>
                            </el-radio-group>
                        </div>
                        <el-input v-if="addQuery.pay_switch == 1" v-model="addQuery.pay_link" placeholder="请输入支付地址" style="width: 400px;"></el-input>
                    </el-form-item>

                    <el-form-item v-if="addQuery.group_switch == 0" label="报名人数上限" prop="enroll_limit" label-width="13%">
                        <el-input-number v-model="addQuery.enroll_limit" placeholder="请输入报名人数"></el-input-number>
                        人
                    </el-form-item>
                    <el-form-item v-if="addQuery.enroll_switch == 1" label="报名是否需要审核" prop="enroll_status" label-width="13%">
                        <el-radio-group v-model="addQuery.enroll_status">
                            <el-radio label="1">需要审核</el-radio>
                            <el-radio label="2">无需审核</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </template>
                <el-button type="primary" @click="tijiao">提交</el-button>
                <el-button @click="caogao">保存为草稿</el-button>
            </el-form>
        </el-card>

        <vxe-modal width="1000" ref="fabuzhe" height="800" size="small" :show-footer="false" title="请选择发布者" :show-close="true">
            <el-card>
                <el-form :inline="true">
                    <el-form-item>
                        <el-input v-model="Querycc.keyword" @input="Discountsearch" placeholder="请输入关键词"></el-input>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-table :data="xiehuiArr" ref="multipleTable" @selection-change="EdithandleSelectionChange" @select="select" @select-all="selectAll" :row-key="(row) => row.user_id">
                <el-table-column type="selection" :reserve-selection="true">
                </el-table-column>
                <el-table-column prop="org_com" label="名称"> </el-table-column>
                <el-table-column prop="pho" label="logo">
                    <template slot-scope="scope">
                        <img :src="scope.row.org_logo" min-width="70" height="70" />
                    </template>
                </el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                        {{ scope.row.types === 1 ? "商会" : "协会" }}
                    </template>
                </el-table-column>
            </el-table>
            <div v-if="pageshow">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[10, 15, 20]" layout="total, sizes, prev, pager, next, jumper" :total="xiehuiTotal">
                </el-pagination>
            </div>
            <div style="margin-top: 200px">
                <el-button type="primary" @click="cclose">确认</el-button>
            </div>
        </vxe-modal>
        <div class="block-none">
            <el-upload class="avatar-uploader1" ref="upload_1" :action="
          editorImgOrVideo === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        " :on-progress="progress" :on-success="uploadSuccess" :limit="1" :before-upload="
          editorImgOrVideo === 'img' ? $beforeUploadImage : $beforeUploadVideo
        " :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" :name="editorImgOrVideo === 'img' ? 'pic' : 'video'" :shrow-file-list="false">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </div>

        <div class="block-none">
            <el-upload class="avatar-uploader2" ref="upload_2" :action="
          editorImgOrVideo2 === 'img'
            ? 'https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic'
            : 'https://ydmxhapi.yundongm.cn:8099/service/admin/uploadvideo'
        " :on-progress="progress" :on-success="uploadSuccess2" :limit="1" :before-upload="
          editorImgOrVideo2 === 'img' ? $beforeUploadImage : $beforeUploadVideo
        " :on-exceed="handleExceed" list-type="picture" :data="{ token: token }" :name="editorImgOrVideo2 === 'img' ? 'pic' : 'video'" :shrow-file-list="false">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
        </div>
        <!-- <Amap v-show="showMap" @onCancel="onCancelMap" @onAddrConfirm="AddrConfirm" /> -->
        <Amap ref="AmapCom" @onAddrConfirm="AddrConfirm" />
        <!-- <search-address ref="searchAddressRef" @onConfirm="AddrConfirm"></search-address> -->

    </div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.15&key=db02839d3d4b5cd28ca4f5d631d303db &plugin=AMap.Geocoder,AMap.Autocomplete,AMap.Geolocation,AMap.PlaceSearch">
</script>
<script>
    import { area, city, province, getWzArea } from "@/api/city";
    import {
        getActiveGroup,
        addActiveGroup,
        editActiveGroup,
        delActiveGroup,
    } from "@/api/huodongfenzu";
    import { actBusinessassociationlist, addAct } from "@/api/tiezi";
    import { getBusinessSportTypeList, getBusinessSportSiteList } from "@/api/shangxiehui";

    import Amap from "../../components/Amap";
    import waves from "../../directive/waves";

    import searchAddress from '../../components/Amap/SearchAddress.vue'

    const toolbarOptions = [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],
        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ align: [] }],
        ["link", "image", "video"],
        ["clean"], // remove formatting button
    ];
    export default {
        name: "index",
        directives: { waves },
        components: { Amap , searchAddress},
        data() {
            const checkActTime = (rule, value, callback) => {
                let enroll_starttime = this.addQuery.enroll_starttime;
                let enroll_endtime = this.addQuery.enroll_endtime;
                let act_starttime = this.addQuery.act_starttime;
                let act_endtime = this.addQuery.act_endtime;

                if (enroll_starttime && enroll_endtime && act_starttime && act_endtime) {
                    enroll_starttime = new Date(
                        enroll_starttime.replace(/-/g, "/")
                    ).getTime();
                    enroll_endtime = new Date(enroll_endtime.replace(/-/g, "/")).getTime();
                    act_starttime = new Date(act_starttime.replace(/-/g, "/")).getTime();
                    act_endtime = new Date(act_endtime.replace(/-/g, "/")).getTime();

                    if (enroll_starttime >= enroll_endtime) {
                        callback(new Error("报名开始时间 必须早于 报名结束时间"));
                    } else if (enroll_starttime > act_starttime) {
                        callback(new Error("活动开始时间 不得早于 报名开始时间"));
                    } else if (act_starttime >= act_endtime) {
                        callback(new Error("活动开始时间 必须早于 活动结束时间"));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };

            return {
                checkSportTypesList: [],
                sportTypes:[],
                sportSites: [],
                areaList: [],
                typeList: [{
                    label: "跑步",
                    value: "1",
                }, {
                    label: "篮球",
                    value: "2",
                }, {
                    label: "羽毛球",
                    value: "3",
                }, {
                    label: "乒乓球",
                    value: "4",
                }, {
                    label: "足球",
                    value: "5",
                }, {
                    label: "游泳",
                    value: "6",
                }, {
                    label: "篮球",
                    value: "7",
                }, {
                    label: "党建活动",
                    value: "10",
                }, {
                    label: "马拉松",
                    value: "11",
                }, {
                    label: "其他",
                    value: "8",
                }, ],
                pageshow: true,
                userform: [],
                token: sessionStorage.getItem("token"),
                spuAddresses: "",
                checkedData: {
                    // sendData: ['province_name'], // 默认选中值
                    typeOptions: {
                        lazy: true, // 开启懒加载
                        lazyLoad: this.lazyLoad,
                    },
                },
                // 限制时间选择器的控制范围
                zanzuList: [],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() <= Date.now();
                    },
                },
                endDatePickercc: this.processDatecc(),
                endDatePicker: this.processDate(),
                labelPosition: "left",
                endTime: "",
                showMap: false,
                mapShowType: "address",
                enrolltime: [],
                acttime: [],
                signintime: [],
                signouttime: [],
                addQuery: {
                    enroll_status: '1',
                    site_type: [],
                    sport_type: [],
                    user_name: "test",
                    user_logo: "test",
                    token: sessionStorage.getItem("token"),
                    user_id: "",
                    space: "",
                    enroll_switch: "0",
                    name: "",
                    type: "1",
                    pics: [],
                    introduce: "",
                    summarize:"",
                    province_id: "",
                    city_id: "",
                    area_id: "",
                    town_id: "",
                    address: "",
                    act_starttime: "",
                    act_endtime: "",
                    enroll_starttime: "",
                    enroll_endtime: "",
                    enroll_limit: "999",
                    enroll_fee: 0,
                    act_sponsor: [],
                    longitude: "",
                    latitude: "",

                    group_switch: '0',
                    act_group_ids: [],

                    signin_type: ['', '', ''],
                    signin_starttime: '',
                    signin_endtime: '',
                    signin_address: '',
                    signin_lng: '',
                    signin_lat: '',
                    signin_distance: 50,
                    signin_qrcode: '',

                    signout_type: ['', '', ''],
                    signout_starttime: '',
                    signout_endtime: '',
                    signout_address: '',
                    signout_lng: '',
                    signout_lat: '',
                    signout_distance: 0,
                    signout_qrcode: '',

                    road_map: '',
                    live_switch: '0',
                    live_type: '1',
                    live_link: '',
                    pay_switch: '0',
                    pay_link: '',
                },
                rules: {
                    enroll_switch: [{ required: true, message: "请选择", trigger: "blur" }],
                    name: [{ required: true, message: "请输入", trigger: "blur" }],
                    type: [{ required: true, message: "请选择", trigger: "blur" }],
                    // space: [{ required: true, message: "请选择", trigger: "blur" }],
                    // act_group_ids: [
                    //     { required: true, type: "array", message: "请添加", trigger: "blur" },
                    // ],
                    // pics: [
                    //     { required: true, type: "array", message: "请上传", trigger: "blur" },
                    // ],
                    introduce: [{ required: true, message: "请输入", trigger: "blur" }],
                    // area_id: [{ required: true, message: "请选择", trigger: "blur" }],
                    address: [{ required: true, message: "请选择", trigger: "blur" }],
                    longitude: [{ required: true, message: "请选择", trigger: "blur" }],
                    act_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    summarize: [{ required: true, message: "请输入", trigger: "blur" }],
                    // area_id: [{ required: true, message: "请选择", trigger: "blur" }],
                    address: [{ required: true, message: "请选择", trigger: "blur" }],
                    longitude: [{ required: true, message: "请选择", trigger: "blur" }],
                    act_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    act_endtime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    enroll_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],
                    enroll_endtime: [
                        { required: true, message: "请选择", trigger: "blur" },
                        { validator: checkActTime, trigger: "blur" },
                    ],

                    // signin_type: [
                    //     { required: true, type: "array", message: "请选择", trigger: "blur" },
                    // ],
                    signin_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                    ],
                    // signin_address: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    // signin_lng: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    signin_distance: [
                        { required: true, message: "请选择", trigger: "blur" },
                    ],
                    // signin_qrcode: [
                    //     { required: true, message: "请上传", trigger: "blur" },
                    // ],

                    // signout_type: [
                    //     { required: true, type: "array", message: "请选择", trigger: "blur" },
                    // ],
                    signout_starttime: [
                        { required: true, message: "请选择", trigger: "blur" },
                    ],
                    signout_address: [
                        { required: true, message: "请选择", trigger: "blur" },
                    ],
                    // signout_lng: [
                    //     { required: true, message: "请选择", trigger: "blur" },
                    // ],
                    signout_distance: [
                        { required: true, message: "请选择", trigger: "blur" },
                    ],
                    // signout_qrcode: [
                    //     { required: true, message: "请上传", trigger: "blur" },
                    // ],

                    enroll_limit: [{ required: true, message: "请输入", trigger: "blur" }],
                    sport_type: [{required:true, message: "请选择", trigger:"blur"}],
                    site_type: [{required:true, message: "请选择", trigger:"blur"}],
                },
                query: {
                    keyword: "",
                    order_status: null,
                    shop_id: null,
                    add_time: null,
                },
                mapShow: false,
                value: "",
                cityArr: [],
                areaArrcc: [],
                Querycc: {
                    token: sessionStorage.getItem("token"),
                    keyword: "",
                    page: 1,
                    pagesize: 10,
                },
                xiehuiArr: [],
                xiehuiTotal: null,
                cur_page: 1,
                xiehuiQuery: {
                    org_com: "",
                },
                // 富文本编辑器配置
                editorOption: {
                    placeholder: "请输入内容",
                    theme: "snow", // or 'bubble'
                    modules: {
                        toolbar: {
                            container: toolbarOptions, // 工具栏
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        this.editorImgOrVideo = "img";
                                        // debugger;
                                        // 触发input框选择图片文件
                                        document.querySelector(".avatar-uploader1 input").click();
                                    } else {
                                        this.quill.format("image", false);
                                    }
                                },
                                video: (value) => {
                                    if (value) {
                                        this.editorImgOrVideo = "video";
                                        // debugger;
                                        // 触发input框选择视频文件
                                        document.querySelector(".avatar-uploader1 input").click();
                                    } else {
                                        this.quill.format("video", false);
                                    }
                                },
                            },
                        },
                    },
                },
                editorImgOrVideo: "img",
                editorOption2: {
                    placeholder: "请输入内容",
                    theme: "snow", // or 'bubble'
                    modules: {
                        toolbar: {
                            container: toolbarOptions, // 工具栏
                            handlers: {
                                image: function(value) {
                                    if (value) {
                                        this.editorImgOrVideo2 = "img";
                                        // debugger;
                                        // 触发input框选择图片文件
                                        document.querySelector(".avatar-uploader2 input").click();
                                    } else {
                                        this.quill.format("image", false);
                                    }
                                },
                                video: (value) => {
                                    if (value) {
                                        this.editorImgOrVideo2 = "video";
                                        // debugger;
                                        // 触发input框选择视频文件
                                        document.querySelector(".avatar-uploader2 input").click();
                                    } else {
                                        this.quill.format("video", false);
                                    }
                                },
                            },
                        },
                    },
                },
                editorImgOrVideo2: "img",

                // 活动分组
                pickerOptionsAge: {
                    disabledDate(time) {
                        const nowYear = new Date().getFullYear();
                        return nowYear - time.getFullYear() < 6;
                    },
                },
                activeGroupForm: {
                    name: "",
                    number: "",
                    ageStart: "",
                    ageEnd: '',
                    age: "",
                    sex: "不限"
                },
                activeGroup: [],
                sexList: [{
                    label: "不限",
                    value: '不限'
                }, {
                    label: "男",
                    value: '男'
                }, {
                    label: "女",
                    value: '女'
                }],

                isSignin: false,
                isNotSignin: true,
                signinType: ['', '', ''],
                signInList: [{
                    label: "定位签到",
                    value: '1'
                }, {
                    label: "扫码签到",
                    value: '2'
                }, {
                    label: "亮码签到",
                    value: '3'
                }],
                signInMiList: [{
                    label: "50米",
                    value: 50
                }, {
                    label: "100米",
                    value: 100
                }, {
                    label: "200米",
                    value: 200
                }],

                isSignout: false,
                isNotSignout: true,
                signoutType: ['', '', ''],
                signOutList: [{
                    label: "定位签退",
                    value: '1'
                }, {
                    label: "扫码签退",
                    value: '2'
                }, {
                    label: "亮码签退",
                    value: '3'
                }],
                signOutMiList: [{
                    label: "50米",
                    value: 50
                }, {
                    label: "100米",
                    value: 100
                }, {
                    label: "200米",
                    value: 200
                }],
            };
        },
        async created() {
            await this.initSportTypes();
            // await this.initSportSiteList();
            this.getAreaList();
        },
        methods: {
            /** 初始化活动类型*/
            initSportTypes(){
                //  获取活动类型
                getBusinessSportTypeList({
                    limit: -1,
                    token: sessionStorage.getItem("token"),
                }).then(resp=>{
                    this.sportTypes = resp.data.data.map(item=>({value:item.id, label:item.title}));
                    console.log("_this.sportTypes", this.sportTypes)
                    // 协会默认选中活动类型
                    let sportType = this.sportTypes.find((sport,index) => index === 0)
                    this.addQuery = { ...this.addQuery, sport_type: [sportType.value] }
                })
            },
            /** 初始化场地列表*/
            // initSportSiteList() {
            //   getBusinessSportSiteList({
            //       limit: -1,
            //       token: sessionStorage.getItem("token"),
            //   }).then(resp=>{
            //       this.sportSites = resp.data.data.map(item=>({value:item.id, label:item.title}));
            //       // 登录协会默认选中场地
            //       let sportSite = this.sportSites.map(sport => sport.value)
            //       this.addQuery = { ...this.addQuery, site_type: sportSite  }
            //   })
            // },
            openjingweidu() {
                this.mapShow = true;
            },
            closeuserLogo() {
                this.addQuery.user_logo = "";
            },
            processDatecc() {
                const self = this;
                return {
                    disabledDate(time) {
                        console.log(time);
                        if (self.addQuery.enroll_starttime) {
                            // 如果开始时间不为空，则结束时间大于开始时间
                            return (
                                new Date(self.addQuery.enroll_starttime).getTime() >
                                time.getTime()
                            );
                        } else {
                            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            processDate() {
                const self = this;
                return {
                    disabledDate(time) {
                        if (self.addQuery.act_starttime) {
                            // 如果开始时间不为空，则结束时间大于开始时间
                            return (
                                new Date(self.addQuery.act_starttime).getTime() > time.getTime()
                            );
                        } else {
                            return time.getTime() > Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            changeEnrolltime(values) {
                if (values) {
                    this.addQuery.enroll_starttime = values[0];
                    this.addQuery.enroll_endtime = values[1];
                } else {
                    this.addQuery.enroll_starttime = '';
                    this.addQuery.enroll_endtime = '';
                }
            },
            changeActtime(values) {
                if (values) {
                    this.addQuery.act_starttime = values[0];
                    this.addQuery.act_endtime = values[1];
                } else {
                    this.addQuery.act_starttime = '';
                    this.addQuery.act_endtime = '';
                }
            },
            inputIsNotSignin(value) {
                this.addQuery.signin_type = ['', '', ''];
            },
            clickSigninType(index) {
                this.$set(this.addQuery.signin_type, index, this.addQuery.signin_type[index] ? '' : this.signInList[index].value);
                this.isNotSignin = !this.addQuery.signin_type.find(item => item);
            },
            inputIsNotSignout(value) {
                this.addQuery.signout_type = ['', '', ''];
            },
            clickSignoutType(index) {
                this.$set(this.addQuery.signout_type, index, this.addQuery.signout_type[index] ? '' : this.signOutList[index].value);
                this.isNotSignout = !this.addQuery.signout_type.find(item => item);
            },
            changeSignintime(values) {
                if (values) {
                    this.addQuery.signin_starttime = values[0];
                    this.addQuery.signin_endtime = values[1];
                } else {
                    this.addQuery.signin_starttime = '';
                    this.addQuery.signin_endtime = '';
                }
            },
            onSuccessSignin_qrcode(response, file, fileList) {
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.signin_qrcode = response.pic_url;
                }
            },
            changeSignouttime(values) {
                if (values) {
                    this.addQuery.signout_starttime = values[0];
                    this.addQuery.signout_endtime = values[1];
                } else {
                    this.addQuery.signout_starttime = '';
                    this.addQuery.signout_endtime = '';
                }
            },
            onSuccessSignout_qrcode(response, file, fileList) {
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.signout_qrcode = response.pic_url;
                }
            },
            caogao() {
                this.$refs.form.clearValidate()
                console.log('_caogao',this.addQuery)
                let signin_type = '0';
                if (!this.isNotSignin) {
                    signin_type = this.addQuery.signin_type.join(',');
                }

                let signout_type = '0';
                if (!this.isNotSignin) {
                    signout_type = this.addQuery.signout_type.join(',');
                }

                this.addQuery = { ...this.addQuery, sport_type: this.addQuery.sport_type.length ? this.addQuery.sport_type.join(","):'', is_status: 0 }
                const obj = {
                    ...this.addQuery,
                    token: sessionStorage.getItem("token"),
                    pics: JSON.stringify(this.addQuery.pics),
                    act_sponsor: JSON.stringify(this.addQuery.act_sponsor),
                    act_group_ids: this.addQuery.group_switch == 1 ? this.activeGroup.map(item => parseInt(item.id)) : [],
                    signin_type,
                    signout_type
                };
                addAct(obj).then(({ data: res }) => {
                    console.log("res", res);
                    if (res.result === -1) {
                        this.$message({
                            message: res.msg,
                            type: "error",
                            duration: "2000",
                        });
                        setTimeout(() => {
                            window.sessionStorage.clear();
                            this.$router.push("/login");
                        }, 1000);
                    }
                    if (res.result === 0) {
                        this.$message({
                            message: res.msg,
                            type: "error",
                            duration: "2000",
                        });
                        return false;
                    }
                    if (res.result === 1) {
                        this.$message({
                            message: res.msg,
                            type: "success",
                            duration: "2000",
                        });

                        // 如果提交数据中活动分组是是自定义分组, 提交分组数据
                        if(this.addQuery.group_switch == 1) {
                          // console.log('_this.activeGroup', this.activeGroup)
                          this.activeGroup.forEach(async (item)=>{
                            await addActiveGroup({
                              token: this.token,
                              act_id: res.data.act_id,
                              title: item.title,
                            })
                          })
                        }


                        this.addQuery = {};
                        this.$router.push("/huodongguanli");
                    }
                });
            },
            tijiao(is_status) {
                this.addQuery.is_status = is_status === 0 ? is_status : 1;
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let signin_type = '0';
                        if (!this.isNotSignin) {
                            signin_type = this.addQuery.signin_type.join(',');
                        }

                        let signout_type = '0';
                        if (!this.isNotSignin) {
                            signout_type = this.addQuery.signout_type.join(',');
                        }

                        //  group_switch 1 是自定义分组

                        this.addQuery = { ...this.addQuery, sport_type: this.addQuery.sport_type.length ? this.addQuery.sport_type.join(",") : '', is_status: 1/* , site_type: this.addQuery.site_type.join(",") */ }
                        const obj = {
                            ...this.addQuery,
                            token: sessionStorage.getItem("token"),
                            pics: JSON.stringify(this.addQuery.pics),
                            act_sponsor: JSON.stringify(this.addQuery.act_sponsor),
                            // act_group_ids: this.addQuery.group_switch == 1 ? this.activeGroup.map(item => parseInt(item.id)) : [], //   TIP: 发布活动成功后提交活动分组数据
                            signin_type,
                            signout_type
                        };
                        console.log("_", obj)
                        addAct(obj).then(async ({ data: res }) => {
                            console.log("res", res);

                            // 如果提交数据中活动分组是是自定义分组, 提交分组数据
                            if(this.addQuery.group_switch == 1) {
                              console.log('_this.activeGroup', this.activeGroup)
                              this.activeGroup.forEach(async (item)=>{
                                await addActiveGroup({
                                  token: this.token,
                                  act_id: res.data.act_id,
                                  title: item.title,
                                })
                              })
                            }


                            if (res.result === -1) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                setTimeout(() => {
                                    window.sessionStorage.clear();
                                    this.$router.push("/login");
                                }, 1000);
                            }
                            if (res.result === 0) {
                                this.$message({
                                    message: res.msg,
                                    type: "error",
                                    duration: "2000",
                                });
                                return false;
                            }
                            if (res.result === 1) {
                                this.$message({
                                    message: res.msg,
                                    type: "success",
                                    duration: "2000",
                                });
                                this.addQuery = {};
                                this.$router.push("/huodongguanli");
                            }
                        });
                    } else {}
                });
            },
            xingbieChange(item, index) {
                if (index === 0) {
                    this.typeList[0].img =
                        "https://ptumao2.5laoye.com/images/radioTrue.png";
                    this.typeList[1].img =
                        "https://ptumao2.5laoye.com/images/radioFalse.png";
                    this.addQuery.space = "室内";
                } else if (index === 1) {
                    this.typeList[0].img =
                        "https://ptumao2.5laoye.com/images/radioFalse.png";
                    this.typeList[1].img =
                        "https://ptumao2.5laoye.com/images/radioTrue.png";
                    this.addQuery.space = "室外";
                }
            },
            Discountsearch() {
                this.cur_page = 1;
                this.List();
                this.pageshow = false; // 让分页隐藏
                this.$nextTick(() => {
                    // 重新渲染分页
                    this.pageshow = true;
                });
            },
            select(selection, row) {
                if (selection.length > 1) {
                    // eslint-disable-next-line camelcase
                    const del_row = selection.shift();
                    this.$refs.multipleTable.toggleRowSelection(del_row, false);
                }
            },
            selectAll(selection) {
                if (selection.length > 1) {
                    selection.length = 1;
                }
            },
            EdithandleSelectionChange(val) {
                console.log("val", val);
                this.xiehuiQuery = val[0];
                this.addQuery.user_id = this.xiehuiQuery.user_id;
                console.log("xiehuiQuery", this.xiehuiQuery);
            },
            handleSizeChange(val) {
                this.Querycc.pagesize = val;
            },
            handleCurrentChange(val) {
                this.Querycc.page = val;
                const obj = {};
                obj.pagesize = this.Querycc.pagesize;
                obj.page = this.Querycc.page;
                obj.keyword = this.Querycc.keyword;
                obj.token = this.Querycc.sessionStorage.getItem("token");
                actBusinessassociationlist(obj).then(({ data: res }) => {
                    this.xiehuiArr = res.list;
                    this.xiehuiTotal = res.total;
                });
            },
            List() {
                actBusinessassociationlist(this.Querycc).then(({ data: res }) => {
                    console.log("rescc", res);
                    this.xiehuiArr = res.list;
                    this.xiehuiTotal = res.total;
                });
            },
            cclose() {
                this.$refs.fabuzhe.close();
            },
            openfabuzhe() {
                this.$refs.fabuzhe.open();
                this.List();
            },
            async lazyLoad(node, resolve) {
                const level = node.level;
                let result;
                let res;
                let param;
                switch (level) {
                    case 0: // 一级
                        res = await getWzArea();
                        result = res.data.data;
                        result.forEach((item) => {
                            item.value = item.code;
                            item.label = item.name;
                            item.leaf = item.code === "330300000000";
                        });
                        break;
                    case 1: // 二级
                        param = {
                            code: node.data.code,
                            pid: node.data.id,
                        };
                        res = await getWzArea(param);
                        result = res.data.data;
                        console.log(result);
                        result.forEach((item) => {
                            item.value = item.code;
                            item.label = item.name;
                            item.leaf = level >= 1;
                        });
                        break;

                    default:
                        result = [];
                        break;
                }
                resolve(result);
            },
            changList(val) {
                this.addQuery.area_id = val[0];
                this.addQuery.town_id = val[1] || "";
            },
            deletecc(index) {
                this.addQuery.act_sponsor.splice(index, 1);
            },
            addzanzucc() {
                this.addQuery.act_sponsor.push({
                    name: "",
                    content: "",
                });
            },
            closeImgs(index) {
                this.addQuery.pics.splice(index, 1);
            },
            beginDate() {
                const self = this;
                return {
                    disabledDate(time) {
                        if (self.query.end_time) {
                            // 如果结束时间不为空，则小于结束时间
                            return new Date(self.query.end_time).getTime() < time.getTime();
                        } else {
                            return time.getTime() >= Date.now(); // 开始时间不选时，结束时间最大值小于等于当天
                        }
                    },
                };
            },
            handleAvatarSuccessLogo(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.user_logo = response.pic_url;
                    console.log(" this.addQuery.user_logo ", this.addQuery.user_logo);
                }
            },
            handleAvatarSuccess(response, file, fileList) {
                console.log("res", response);
                if (response.result === 1) {
                    this.$message({
                        message: response.msg,
                        type: "success",
                        duration: "2000",
                    });
                    this.addQuery.pics.push({
                        name: response.pic_url,
                    });
                    console.log(" this.addQuery.pic ", this.addQuery.pic);
                }
            },
            beforeUpload(file) {
                const promise = new Promise((resolve) => {
                    this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise; // 通过返回一个promis对象解决
            },
            progress(event, file, fileList) {
                console.log("event", event, "file", file, "fileList", fileList);
                // this.addquery.font_url.push({ name: file })
            },
            // 文件数量过多时提醒
            handleExceed() {
                // this.$message({ type: 'info', message: '最多支持5个附件上传' })
            },
            uploadSuccess(res, file) {
                this.$refs.upload_1.clearFiles();
                // res为图片服务器返回的数据
                // 获取富文本组件实例
                let quill = this.$refs.myQuillEditor.quill;
                // 如果上传成功
                if (res.result === 1) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片  res.info为服务器返回的图片地址
                    if (this.editorImgOrVideo === "img") {
                        quill.insertEmbed(length, "image", res.pic_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    } else {
                        quill.insertEmbed(length, "video", res.video_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    }

                    this.$forceUpdate();
                } else {
                    this.$message.error("图片插入失败");
                }
            },
            uploadSuccess2(res,file){
              this.$refs.upload_2.clearFiles();
                // res为图片服务器返回的数据
                // 获取富文本组件实例
                let quill = this.$refs.myQuillEditor2.quill;
                // 如果上传成功
                if (res.result === 1) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片  res.info为服务器返回的图片地址
                    if (this.editorImgOrVideo2 === "img") {
                        quill.insertEmbed(length, "image", res.pic_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    } else {
                        quill.insertEmbed(length, "video", res.video_url);
                        // 调整光标到最后
                        quill.setSelection(length + 1);
                    }

                    this.$forceUpdate();
                } else {
                    this.$message.error("图片插入失败");
                }
            },
            async getAreaList() {
                try {
                    const res = await getWzArea();
                    const result = res.data.data;
                    result.forEach((item) => {
                        item.value = item.code;
                        item.label = item.name;
                    });
                    this.areaList = result;
                } catch (error) {
                    console.log(error);
                }
            },
            GetJWD(type, signDistance, address, lng, lat) {
                this.mapShowType = type;
                this.$refs.AmapCom.initMap(type, signDistance, address, lng, lat)
                // this.$refs.searchAddressRef.init({ type:'address', address: this.addQuery.org_address, lng: this.addQuery.org_longitude, lat: this.addQuery.org_latitude })
            },
            onCancelMap() {
                this.showMap = false;
            },
            AddrConfirm(res) {
                console.log("onAddrConfirm", res);
                this.showMap = false;
                switch (this.mapShowType) {
                    case "address":
                        this.addQuery.address = res.address
                        this.addQuery.longitude = res.lng;
                        this.addQuery.latitude = res.lat;

                        this.addQuery.signin_address = res.address
                        this.addQuery.signin_lng = res.lng;
                        this.addQuery.signin_lat = res.lat;
                        this.addQuery.signin_distance = res.range;

                        if (!this.addQuery.signout_address) {
                            this.addQuery.signout_address = res.address
                            this.addQuery.signout_lng = res.lng;
                            this.addQuery.signout_lat = res.lat;
                        }
                        if (!this.addQuery.signout_distance) {
                            this.addQuery.signout_distance = res.range;
                        }
                        break;
                    case "qiandao":
                        // this.addQuery.signin_lng = res.lng;
                        // this.addQuery.signin_lat = res.lat;
                        // this.addQuery.signin_address = res.address
                        // this.addQuery.signin_distance = res.range
                        this.addQuery.address = res.address
                        this.addQuery.longitude = res.lng;
                        this.addQuery.latitude = res.lat;

                        this.addQuery.signin_address = res.address
                        this.addQuery.signin_lng = res.lng;
                        this.addQuery.signin_lat = res.lat;
                        this.addQuery.signin_distance = res.range;
                        break;
                    case "qiantui":
                        this.addQuery.signout_lng = res.lng;
                        this.addQuery.signout_lat = res.lat;
                        this.addQuery.signout_address = res.address
                        this.addQuery.signout_distance = res.range
                        break;
                    default:
                        break;
                }
                this.addQuery.longitude = res.lng;
                this.addQuery.latitude = res.lat;
            },
            addGroup2(){
              const activeGroupForm = this.activeGroupForm;
              if (activeGroupForm.ageEnd && activeGroupForm.ageStart) {
                if (activeGroupForm.ageEnd > activeGroupForm.ageStart) {
                    this.$message({
                        message: '年龄选择有误',
                        type: "error",
                    });
                    return;
                }
                activeGroupForm.age = activeGroupForm.ageEnd + ' - ' + activeGroupForm.ageStart;
              }
              if (activeGroupForm.name && activeGroupForm.number && activeGroupForm.age && activeGroupForm.sex) {
                const title = activeGroupForm.name + ',' + activeGroupForm.number + ',' + activeGroupForm.age + ',' + activeGroupForm.sex;

                this.activeGroup.push({
                  title,
                  ...activeGroupForm,
                });
                this.activeGroupForm = {
                    name: '',
                    number: '',
                    ageStart: '',
                    ageEnd: '',
                    age: '',
                    sex: '不限'
                };
              }

            },
            addGroup() {
                const act_id = 0;
                const activeGroupForm = this.activeGroupForm;
                if (activeGroupForm.ageStart && activeGroupForm.ageEnd) {
                    // const nowYear = new Date().getFullYear();
                    // const ageStart = nowYear - activeGroupForm.ageStart + 1;
                    // const ageEnd = nowYear - activeGroupForm.ageEnd + 1;
                    // activeGroupForm.age = ageStart + '到' + ageEnd;
                    if (activeGroupForm.ageStart > activeGroupForm.ageEnd) {
                        this.$message({
                            message: '年龄选择有误',
                            type: "error",
                        });
                        return;
                    }
                    activeGroupForm.age = activeGroupForm.ageStart + ' - ' + activeGroupForm.ageEnd;
                }
                if (activeGroupForm.name && activeGroupForm.number && activeGroupForm.age && activeGroupForm.sex) {
                    const title = activeGroupForm.name + ',' + activeGroupForm.number + ',' + activeGroupForm.age + ',' + activeGroupForm.sex;
                    addActiveGroup({
                        token: this.token,
                        act_id,
                        title,
                    }).then(({ data: res }) => {
                        this.activeGroupForm = {
                            name: '',
                            number: '',
                            ageStart: '',
                            ageEnd: '',
                            age: '',
                            sex: '不限'
                        };
                        this.activeGroup.push({
                            act_id,
                            id: res.data.id,
                            title,
                            ...activeGroupForm,
                        });
                        this.addQuery.act_group_ids = this.activeGroup.map((item) =>
                            parseInt(item.id)
                        );
                    });
                }
            },
            deleteGroup(item, index) {
                this.activeGroup.splice(index, 1);
                // delActiveGroup({
                //     token: this.token,
                //     id: item.id,
                // }).then((res) => {
                //     this.activeGroup.splice(index, 1);
                //     this.addQuery.act_group_ids = this.activeGroup.map((item) =>
                //         parseInt(item.id)
                //     );
                // });
            },
        },
    };
</script>

<style lang="less">
    .search-box {
        border: 1px solid #ccc;
        width: 100%;
    }

    .search-box-wrapper {
        width: 100%;
    }

    .amap-page-container {
        width: 500px;
        height: 500px;
        z-index: 999;
    }

    .amap-demo {
        height: 300px;
        height: 300px;
    }

    .radiobox {
        display: flex;
        flex-direction: row;
        align-items: center;

        .samnfa {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-right: 10px;

            .imgs {
                width: 20px;
                height: 20px;
                opacity: 1;
                margin-right: 20px;
            }
        }
    }

    .el-upload-list {
        display: none;
    }

    .from {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .imgbox {
        width: 188px;
        height: 188px;
        opacity: 1;
        background: rgba(0, 0, 0, 0);
        border-radius: 5px;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;

        .imgs {
            width: 100%;
            height: 100%;
        }

        .close {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 20px;
            opacity: 1;
            background: #e54848;
            border-radius: 50%;
        }
    }

    .el-scrollbar__wrap {
        height: 200px;
    }

    .fabuzhe {
        width: 294px;
        height: 44px;
        opacity: 1;
        background: #fbfbfb;
        border-radius: 5px;
        padding-left: 12px;
        display: flex;
        justify-content: left;
    }

    .ml {
        margin-left: 10px;
    }

    .formClass {
        display: flex;
        flex-direction: column;
    }

    .addzanzu {
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #3d9aff;
    }

    .body {
        display: flex;
        flex-direction: column;

        .title {
            opacity: 1;
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Heavy;
            font-weight: 800;
            text-align: left;
            color: #2e2e2e;
            letter-spacing: 0px;
            margin-bottom: 35px;
            display: flex;
            flex-direction: row;
            align-items: center;

            .fansk {
                margin-top: 30px;
                margin-left: 32px;
            }

            .dsadf {
                color: #3d9aff;
            }
        }
    }

    .block-none {
        display: none;
    }
</style>
